export default __webpack_public_path__ + "media/images/ui-icons_555555_256x240-00dd0ec0a16a1085e714c7906ff8fb06.png";